import { Category } from '../category';

export class CategoryData {
    category: Category;
}
